export enum DashboardCardState {
  LOADED,
  NOT_LOADED,
  STALE
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/dashboard/dashboard-card-state.ts